import * as types from "../actionTypes";
import initialState from "../../../reducers/initialState";
import { combineReducers } from "redux";

const shareholdersReducer = (state = initialState.shareholders, action) => {
  switch (action.type) {
    case types.LOAD_SHAREHOLDERS_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: true, loaded: false };
      return result;
    }

    case types.LOAD_SHAREHOLDERS_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true, ids: action.result };
      return result;
    }

    case types.LOAD_SHAREHOLDERS_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...result[key], loading: false, loaded: false };
      return result;
    }

    case types.UPDATE_SHAREHOLDERS_SUCCEEDED: {
      const { partnerId, ids } = action;
      let result = { ...state };
      result[partnerId] = { ...result[partnerId], loading: false, loaded: true, ids: ids };
      return result;
    }

    default:
      return state;
  }
};

export default combineReducers({
  list: shareholdersReducer
});
